webpackJsonp([155329947031394],{

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(14);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHome = function FaHome(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm32.9 22.1v10.8q0 0.5-0.4 1t-1 0.4h-8.6v-8.6h-5.7v8.6h-8.6q-0.5 0-1-0.4t-0.4-1v-10.8q0 0 0 0t0-0.1l12.9-10.6 12.8 10.6q0 0.1 0 0.1z m5-1.5l-1.4 1.7q-0.2 0.2-0.4 0.2h-0.1q-0.3 0-0.5-0.2l-15.4-12.8-15.5 12.8q-0.2 0.2-0.5 0.2-0.3 0-0.5-0.2l-1.4-1.7q-0.1-0.2-0.1-0.5t0.2-0.5l16.1-13.4q0.7-0.6 1.7-0.6t1.7 0.6l5.4 4.6v-4.4q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5v9.1l4.9 4.1q0.2 0.2 0.3 0.5t-0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaHome;
	module.exports = exports['default'];

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * simpleParallax.min - simpleParallax is a simple JavaScript library that gives your website parallax animations on any images, 
	 * @date: 13-06-2019 16:24:29, 
	 * @version: 5.1.0,
	 * @link: https://simpleparallax.com/
	 */
	!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("simpleParallax",[],e):"object"==typeof exports?exports.simpleParallax=e():t.simpleParallax=e()}(window,function(){return(n={},s.m=i=[function(t,e,i){"use strict";function n(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}i.r(e);var s=function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.positions={top:0,bottom:0,height:0}}return function(t,e,i){e&&n(t.prototype,e),i&&n(t,i)}(t,[{key:"setViewportTop",value:function(){return this.positions.top=window.pageYOffset,this.positions}},{key:"setViewportBottom",value:function(){return this.positions.bottom=this.positions.top+this.positions.height,this.positions}},{key:"setViewportHeight",value:function(){return this.positions.height=document.documentElement.clientHeight,this.positions}},{key:"setViewportAll",value:function(){return this.positions.top=window.pageYOffset,this.positions.bottom=this.positions.top+this.positions.height,this.positions.height=document.documentElement.clientHeight,this.positions}}]),t}(),o=function(t){return NodeList.prototype.isPrototypeOf(t)||HTMLCollection.prototype.isPrototypeOf(t)?Array.from(t):"string"==typeof t||t instanceof String?document.querySelectorAll(t):[t]},r=function(){for(var t,e="transform webkitTransform mozTransform oTransform msTransform".split(" "),i=0;void 0===t;)t=void 0!==document.createElement("div").style[e[i]]?e[i]:void 0,i+=1;return t}(),a=function(t){return!!t&&(!!t.complete&&(void 0===t.naturalWidth||0!==t.naturalWidth))};function l(t){return function(t){if(Array.isArray(t)){for(var e=0,i=new Array(t.length);e<t.length;e++)i[e]=t[e];return i}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function u(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}var h=function(){function i(t,e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),this.element=t,this.elementContainer=t,this.settings=e,this.isVisible=!0,this.isInit=!1,this.oldTranslateValue=-1,this.init=this.init.bind(this),a(t)?this.init():this.element.addEventListener("load",this.init)}return function(t,e,i){e&&u(t.prototype,e),i&&u(t,i)}(i,[{key:"init",value:function(){this.isInit||this.element.closest(".simpleParallax")||(!1===this.settings.overflow&&this.wrapElement(this.element),this.setStyle(),this.getElementOffset(),this.intersectionObserver(),this.getTranslateValue(),this.animate(),this.isInit=!0)}},{key:"wrapElement",value:function(){var t=this.element.closest("picture")||this.element,e=document.createElement("div");e.classList.add("simpleParallax"),e.style.overflow="hidden",t.parentNode.insertBefore(e,t),e.appendChild(t),this.elementContainer=e}},{key:"unWrapElement",value:function(){var t=this.elementContainer;t.replaceWith.apply(t,l(t.childNodes))}},{key:"setStyle",value:function(){!1===this.settings.overflow&&(this.element.style[r]="scale(".concat(this.settings.scale,")")),0<this.settings.delay&&(this.element.style.transition="transform ".concat(this.settings.delay,"s ").concat(this.settings.transition)),this.element.style.willChange="transform"}},{key:"unSetStyle",value:function(){this.element.style.willChange="",this.element.style[r]="",this.element.style.transition=""}},{key:"getElementOffset",value:function(){var t=this.elementContainer.getBoundingClientRect();this.elementHeight=t.height,this.elementTop=t.top+d.positions.top,this.elementBottom=this.elementHeight+this.elementTop}},{key:"buildThresholdList",value:function(){for(var t=[],e=1;e<=this.elementHeight;e++){var i=e/this.elementHeight;t.push(i)}return t}},{key:"intersectionObserver",value:function(){var t={root:null,threshold:this.buildThresholdList()};this.observer=new IntersectionObserver(this.intersectionObserverCallback.bind(this),t),this.observer.observe(this.element)}},{key:"intersectionObserverCallback",value:function(t){for(var e=t.length-1;0<=e;e--)t[e].isIntersecting?this.isVisible=!0:this.isVisible=!1}},{key:"checkIfVisible",value:function(){return this.elementBottom>d.positions.top&&this.elementTop<d.positions.bottom}},{key:"getRangeMax",value:function(){var t=this.element.clientHeight;this.rangeMax=t*this.settings.scale-t}},{key:"getTranslateValue",value:function(){var t=((d.positions.bottom-this.elementTop)/((d.positions.height+this.elementHeight)/100)).toFixed(1);return t=Math.min(100,Math.max(0,t)),this.oldPercentage!==t&&(this.rangeMax||this.getRangeMax(),this.translateValue=(t/100*this.rangeMax-this.rangeMax/2).toFixed(0),this.oldTranslateValue!==this.translateValue&&(this.oldPercentage=t,this.oldTranslateValue=this.translateValue,!0))}},{key:"animate",value:function(){var t,e=0,i=0;(this.settings.orientation.includes("left")||this.settings.orientation.includes("right"))&&(i="".concat(this.settings.orientation.includes("left")?-1*this.translateValue:this.translateValue,"px")),(this.settings.orientation.includes("up")||this.settings.orientation.includes("down"))&&(e="".concat(this.settings.orientation.includes("up")?-1*this.translateValue:this.translateValue,"px")),t=!1===this.settings.overflow?"translate3d(".concat(i,", ").concat(e,", 0) scale(").concat(this.settings.scale,")"):"translate3d(".concat(i,", ").concat(e,", 0)"),this.element.style[r]=t}}]),i}();function c(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}i.d(e,"viewport",function(){return d}),i.d(e,"default",function(){return b});var f,p,m,d=new s,g=!0,v=!1,y=[],b=function(){function i(t,e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),t&&(this.elements=o(t),this.defaults={delay:.4,orientation:"up",scale:1.3,overflow:!1,transition:"cubic-bezier(0,0,0,1)",breakpoint:!1},this.settings=Object.assign(this.defaults,e),this.settings.breakpoint&&document.documentElement.clientWidth<=this.settings.breakpoint||("IntersectionObserver"in window||(g=!1),this.lastPosition=-1,this.resizeIsDone=this.resizeIsDone.bind(this),this.handleResize=this.handleResize.bind(this),this.proceedRequestAnimationFrame=this.proceedRequestAnimationFrame.bind(this),this.init()))}return function(t,e,i){e&&c(t.prototype,e),i&&c(t,i)}(i,[{key:"init",value:function(){d.setViewportAll();for(var t=this.elements.length-1;0<=t;t--){var e=new h(this.elements[t],this.settings);y.push(e)}f=y.length,v||(this.proceedRequestAnimationFrame(),window.addEventListener("resize",this.resizeIsDone),v=!0)}},{key:"resizeIsDone",value:function(){clearTimeout(m),m=setTimeout(this.handleResize,500)}},{key:"handleResize",value:function(){d.setViewportAll(),this.settings.breakpoint&&document.documentElement.clientWidth<=this.settings.breakpoint&&this.destroy();for(var t=f-1;0<=t;t--)y[t].getElementOffset(),y[t].getRangeMax();this.lastPosition=-1}},{key:"proceedRequestAnimationFrame",value:function(){if(d.setViewportTop(),this.lastPosition!==d.positions.top){d.setViewportBottom();for(var t=f-1;0<=t;t--)this.proceedElement(y[t]);p=window.requestAnimationFrame(this.proceedRequestAnimationFrame),this.lastPosition=d.positions.top}else p=window.requestAnimationFrame(this.proceedRequestAnimationFrame)}},{key:"proceedElement",value:function(t){(g?t.isVisible:t.checkIfVisible())&&t.getTranslateValue()&&t.animate()}},{key:"destroy",value:function(){var e=this,i=[];y=y.filter(function(t){if(!e.elements.includes(t.element))return t;i.push(t)});for(var t=i.length-1;0<=t;t--)i[t].unSetStyle(),!1===this.settings.overflow&&i[t].unWrapElement();(f=y.length)||(window.cancelAnimationFrame(p),window.removeEventListener("resize",this.handleResize))}}]),i}()}],s.c=n,s.d=function(t,e,i){s.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i})},s.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},s.t=function(e,t){if(1&t&&(e=s(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var i=Object.create(null);if(s.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var n in e)s.d(i,n,function(t){return e[t]}.bind(null,n));return i},s.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return s.d(e,"a",e),e},s.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},s.p="",s(s.s=0)).default;function s(t){if(n[t])return n[t].exports;var e=n[t]={i:t,l:!1,exports:{}};return i[t].call(e.exports,e,e.exports,s),e.l=!0,e.exports}var i,n});

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tulsa-1.23a9fe62.jpg";

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tulsa-2.81146c74.jpg";

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tulsa-3.34ee27d0.jpg";

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(83);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _home = __webpack_require__(56);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _tulsa = __webpack_require__(497);
	
	var _tulsa2 = _interopRequireDefault(_tulsa);
	
	var _tulsa3 = __webpack_require__(498);
	
	var _tulsa4 = _interopRequireDefault(_tulsa3);
	
	var _tulsa5 = __webpack_require__(151);
	
	var _tulsa6 = _interopRequireDefault(_tulsa5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var simpleParallax = void 0;
	
	var MCF23 = function (_Component) {
	    _inherits(MCF23, _Component);
	
	    function MCF23() {
	        _classCallCheck(this, MCF23);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    MCF23.prototype.componentDidMount = function componentDidMount() {
	        var hamburger = document.querySelector('.nav-hamburger');
	        hamburger.style.display = 'none';
	
	        simpleParallax = __webpack_require__(61);
	        var tulsaImages = document.querySelectorAll('.tulsa-img');
	        new simpleParallax(tulsaImages, { scale: 1.1 });
	    };
	
	    MCF23.prototype.componentWillUnmount = function componentWillUnmount() {
	        var hamburger = document.querySelector('.nav-hamburger');
	        hamburger.style.display = 'block';
	    };
	
	    MCF23.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'project-page' },
	            _react2.default.createElement(_reactHelmet2.default, {
	                title: 'MCF23 | Maslow Development Inc.',
	                meta: [{ name: 'description', content: 'We co-design & develop real estate and community ecosystems.' }, { name: 'keywords', content: 'maslow, maslow development, maslow development inc, real estate, community development, community developer, community planner, real estate development, real estate developer, real estate design, real estate designer' }]
	            }),
	            _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/#highlighted-projects', className: 'project-page-link-home' },
	                '\u2190',
	                _react2.default.createElement(_home2.default, { className: 'link-home-icon' })
	            ),
	            _react2.default.createElement(
	                'h6',
	                { className: 'project-page-label' },
	                'Highlighted Project'
	            ),
	            _react2.default.createElement(
	                'h1',
	                { className: 'project-page-title' },
	                'MCF23'
	            ),
	            _react2.default.createElement(
	                'h5',
	                { className: 'project-page-blurb' },
	                'Reimagining Black Wall Street in North Tulsa'
	            ),
	            _react2.default.createElement(
	                'section',
	                { className: 'project-page-hero' },
	                _react2.default.createElement('img', { src: _tulsa2.default, className: 'project-page-hero-image tulsa-img', alt: 'Clayborn Temple' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'project-page-details' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'project-page-detail' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Challenge'
	                        ),
	                        'How might we reinvest in and empower a community that was once a hub for economic opportunity and vitality?'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'project-page-detail' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Solution'
	                        ),
	                        'A 23-acre, mixed-use community with an acute focus on business & entrepreneurship to create an ecosystem around economic sustainability.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'project-page-detail' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Team'
	                        ),
	                        'Maslow Development Inc. & Met Cares Foundation'
	                    )
	                )
	            ),
	            _react2.default.createElement('img', { src: _tulsa4.default, className: 'project-page-full-image tulsa-img', alt: 'Clayborn Temple' }),
	            _react2.default.createElement(
	                'h3',
	                { className: 'project-page-quote' },
	                'MCF is committed to transforming the academic and social outcomes for families living in North Tulsa by operating great schools, engaging the community, and ensuring that robust economic development can thrive, all in an effort to return North Tulsa to the greatness it achieved in the early 1900\u2019s when it was the financial and business center of the United States and Black excellence was synonymous with that success.',
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u2014 Ray Owens, Chairman, Met Cares Foundation'
	                )
	            ),
	            _react2.default.createElement('img', { src: _tulsa6.default, className: 'project-page-full-image tulsa-img', alt: 'Clayborn Temple' })
	        );
	    };
	
	    return MCF23;
	}(_react.Component);
	
	exports.default = MCF23;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-mcf-23-js-42c4b022ac12363454f0.js